module.exports = __webpack_public_path__ + "img/comp-sinlinx.94d5045a.svg";